export default "__VITE_PUBLIC_ASSET__17194469__"